module.exports = __webpack_public_path__ + "static/media/iconequip.7af20bc1.svg";